import { render, staticRenderFns } from "./ModalLegalCandidatos.vue?vue&type=template&id=0bab0885&"
import script from "./ModalLegalCandidatos.vue?vue&type=script&lang=js&"
export * from "./ModalLegalCandidatos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports